<template>
    <div id="dashboard-analytics">
        <div class="vx-row" v-if="!hasMoreThanOneLogin">
            <!-- CARD 1: CONGRATS -->
            <div class="vx-col w-full  mb-base">
                <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
                  <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left"
                       width="200">
                  <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right"
                       width="175">
                    <feather-icon icon="AwardIcon"
                                  class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                                  svgClasses="h-8 w-8"></feather-icon>
                    <h1 class="mb-6 text-white">Congratulation</h1>
                    <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white text-xl">

                      You are now a member of Cyrus Empire!
                      <br>
                      Enjoy our royal member discounts!
                    </p>
                </vx-card>
            </div>


        </div>


        <div class="vx-row">
            <!-- CARD 9: DISPATCHED ORDERS -->
            <div class="vx-col w-full">
                <vx-card title="My Last Orders">
                    <div slot="no-body" class="mt-4">
                        <vs-table :data="orders" class="table-dark-inverted">
                            <template slot="thead">
                                <vs-th>Order Number</vs-th>
                              <vs-th>Order Date</vs-th>
                              <vs-th>Status</vs-th>
                              <vs-th>Order Amount</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="tr.id">
                                        <span>CBS_ORDER-{{tr.id}}</span>
                                    </vs-td>
                                    <vs-td :data="tr.created_at">
                                      <p class="product-category">{{ tr.created_at }}</p>
                                    </vs-td>
                                    <vs-td :data="data[indextr].status">
                                      <vs-chip :color="getOrderStatusColor(tr.sts)" class="product-order-status">
                                        {{ tr.sts_str }}
                                      </vs-chip>
                                    </vs-td>
                                    <vs-td :data="tr.total_price">
                                        <span>{{tr.total_price | price}}</span>
                                    </vs-td>

                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>

                </vx-card>
            </div>
        </div>

    </div>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts'
    import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
    import analyticsData from './ui-elements/card/analyticsData.js'
    import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
    import VxTimeline from "@/components/timeline/VxTimeline"

    export default {
        data() {
            return {
                checkpointReward: {},
                subscribersGained: {},
                ordersRecevied: {},
                salesBarSession: {},
                supportTracker: {},
                productsOrder: {},
                salesRadar: {},
                analyticsData: analyticsData,
            }
        },
        components: {
            VueApexCharts,
            StatisticsCardLine,
            ChangeTimeDurationDropdown,
            VxTimeline
        },
      computed:{
        orders(){

          return this.$store.state.order.list
        },
        hasMoreThanOneLogin(){
          console.log('localStorage.getItem(\'count_login\')' , localStorage.getItem('count_login'));
          return localStorage.getItem('count_login') > 1;
        }
      },
        methods: {
          getOrderStatusColor(status) {
            if (status == 1) return "warning"
            if (status == 2) return "success"
            if (status == 3) return "danger"
            return "primary"
          },
        },
        created() {
            // this.$http.post("/customer/order", item)
            //     .then((response) => {
            //         this.orders = response;
            //     })
            //     .catch((error) => {
            //
            //     })
          this.$store.dispatch('order/fetch')
        }
    }
</script>

<style lang="scss">
    #dashboard-analytics {
        .greet-user {
            position: relative;

            .decore-left {
                position: absolute;
                left: 0;
                top: 0;
            }

            .decore-right {
                position: absolute;
                right: 0;
                top: 0;
            }
        }

        @media(max-width: 576px) {
            .decore-left, .decore-right {
                width: 140px;
            }
        }
    }
</style>
